<template>
    <b-row class="px-sm-4 px-md-4 px-lg-2 pt-sm-3">
      <b-col cols="12">
        <PageTitle title="Carteira Parceiros" />
      </b-col>
     
      <b-col cols="12" class="mb-4">
       Histórico de vendas e recebimentos dos parceiros
      </b-col>

      <b-col cols="12">
        <b-row>
          <b-col cols="12" md="3">
            <b-card
              border-variant="warning"
              header-bg-variant="warning"
              header-text-variant="white"
              align="center"
            >
            <template #header>
              <b-card-title class="my-2 fs-22 text-white">Valor Retido</b-card-title>
            </template>
              <b-card-text class="fs-22">{{ formatMoneyUn(values.waitingForDeadline) }}</b-card-text>
           </b-card>
          </b-col>

          <b-col cols="12" md="3">
            <b-card
              border-variant="primary"
              header-bg-variant="primary"
              header-text-variant="white"
              align="center"
            >
              <template #header>
                <b-card-title class="my-2 fs-22 text-white">Valor a Transferir</b-card-title>
              </template>
                <b-card-text class="fs-24">{{ formatMoneyUn(this.values.waitingPayment) }}</b-card-text>
            </b-card>
          </b-col>

          <b-col cols="12" md="3">
            <b-card
              border-variant="success"
              header-bg-variant="success"
              header-text-variant="white"
              align="center"
            >
            <template #header>
              <b-card-title class="my-2 fs-22 text-white">Meus Ganhos</b-card-title>
            </template>
              <b-card-text class="fs-24">{{ formatMoneyUn(this.values.valueGained) }}</b-card-text>
           </b-card>
          </b-col>

          <b-col cols="12" md="3">
            <b-card
              border-variant="info"
              header-bg-variant="info"
              header-text-variant="white"
              align="center"
            >
            <template #header>
              <b-card-title class="my-2 fs-22 text-white">Valores Transferidos</b-card-title>
            </template>
              <b-card-text class="fs-24">{{ formatMoneyUn(this.values.amountPain) }}</b-card-text>
           </b-card>
          </b-col>
        </b-row>
      </b-col>

      <b-col cols="12" class="mt-5">
        <PeriodsFilters
          ref="periodsFilters"
          :setDatesAutomatic="false"
          :startDate.sync="fields.startDate"
          :endDate.sync="fields.endDate"
          @click.native="searchDate()"
        />
      </b-col>
      
      <!-- Implementar posteriormente -->
      <!-- <b-col cols="12" class="mt-5">
        <StatusFilter
          ref="statusFilter"
          @search="searchStatus()"
        />
      </b-col> -->

      <b-col cols="12" class="mt-4 d-flex justify-content-around">
        <b-form-input
          v-model="fields.partnerName"
          type="text"
          style="max-width: 80%;"
          placeholder="Digite o nome do parceiro"
          @change="searchName()"
        ></b-form-input>
        <b-button
          class="ml-2"
          style="min-width: 15%;"
          variant="success"
          @click="searchName()"
        >Pesquisar</b-button>
        
        <b-button
          class="ml-2"
          style="min-width: 15%;"
          variant="warning"
          @click="clearFields()"
        >Limpar Pesquisa</b-button>
      </b-col>


      <b-col cols="12" class="mt-4 d-flex justify-content-end">
        <b-button 
          :disabled="!values.waitingPayment"
          variant="primary" 
          class="mt-2"
          @click="$refs.transferModal.toggleOpen({
            idShopkeeper: dadosUsuario.id,
            partners: partners,
          })"
        >Realizar Transferencia para os Parceiros</b-button>
      </b-col>

      <b-col cols="12" class="mt-4">
        <h4 class="text-center">Histórico de movimentação</h4>
      </b-col>

      <b-col cols="12" class="mt-3">
        <b-table
          striped
          bordered
          hover
          show-empty
          responsive
          empty-text="Sem histórico de movimentação"
          :fields="table.headers"
          :items="table.items"
          :busy="loading"
        >
        <template #cell(actions)="data">
          <b-button
            size="sm"
            class="mx-2"
            variant="warning"
            title="Detalhes do histórico"
            @click="$refs.detailPaymentPartnerModal.toggleOpen({
              idPaymentPartner: data.item.id,
              idShopkeeper: dadosUsuario.id,
              partner: getDataPartner(data.item.partnerId),
              orderData: data.item,
            })"
          >
            <i class="fas fa-eye"></i> 
          </b-button>
          
          <b-button
              variant="outline-dark"
              size="sm"
              v-b-tooltip.hover
              title="Detalhes do pedido"
              class="mr-1"
              @click="
                $refs.orderDetails.toggleOpen({
                  orderId: data.item.dataPayment[0].id,
                  uuid: data.item.dataPayment[0].uuid,
                  dataModal: data.item.dataPayment[0]
                })
              "
            >
              <i class="fas fa-eye"></i>
            </b-button>
        </template>

        <template #cell(namePartner)="data">
          {{ getNamePartner(data.item.partnerId) }}
        </template>
        
        <template #cell(uuid)="data">
          {{ data.item.dataPayment[0].uuid }}
        </template>

        <template #cell(percentage)="data">
          {{ parseFloat(data.item.percentage) }} %
        </template>

        </b-table>
      </b-col>
      <b-col cols="12" class="d-flex align-items-center justify-content-center">
      <b-pagination
        v-model="pagination.currentPage"
        :total-rows="pagination.total"
        :per-page="pagination.itemsPerPage"
        :disabled="loading"
      ></b-pagination>
      </b-col>

      <detail-payment-partner-modal 
        ref="detailPaymentPartnerModal"
      />

      <TransferModal 
        ref="transferModal"
      />

      <OrderDetails
        ref="orderDetails"
        :data="[]"
      />
    </b-row>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import PageTitle from 'Components/PageTitle.vue';
import shopkeeperAppApi from '@/api/shopkeeperAppApi';
import { formatMoney } from '@/utils/number';
import makeToast from '@/mixins/makeToast';
import { mapLabel } from '@/enums/Partner/PaymentPartnerStatus';
import DetailPaymentPartnerModal from '../../../components/partner/DetailPaymentPartnerModal.vue';
import TransferModal from '../../../components/partner/TransferModal.vue';
import PeriodsFilters from 'Components/Inputs/PeriodsFilters.vue';
import StatusFilter from '@/components/partner/StatusFilter.vue';
import OrderDetails from 'Components/Order/OrderDetails.vue';

export default {
  name:'PartnersProducts',
  mixins: [makeToast],
  components: {
    PageTitle,
    DetailPaymentPartnerModal,
    TransferModal,
    PeriodsFilters,
    StatusFilter,
    OrderDetails
  },
  computed: {
    ...mapState(['dadosUsuario']),
  },
  data() {
    return {
      loading: false,
      partners: [],
      table: {
        headers: [
          {
            key: 'id',
            thClass: 'd-none',
            tdClass: 'd-none',
          },
          {
            key: 'uuid',
            label: 'Pedido',
            sortable: false,
          },
          {
            key: 'updatedAt',
            label: 'Data',
            sortable: false,
          },
          {
            key: 'namePartner',
            label: 'Parceiro',
            sortable: false,
          },
          {
            key: 'status',
            label: 'Status',
            sortable: false,
            formatter(value){
              return mapLabel(value);
            }
          },
          {
            key: 'totalValueProduct',
            label: 'Total Produto',
            sortable: false,
            formatter(value){
              return formatMoney(value);
            } 
          },
          {
            key: 'valuePartner',
            label: 'Valor Parceiro',
            sortable: false,
            formatter(value){
              return formatMoney(value);
            }
          },
          {
            key: 'percentage',
            label: 'Lucro em %',
            sortable: false,
          },
          {
            key: 'valueShopkeeper',
            label: 'Lucro',
            sortable: false,
            formatter(value){
              return formatMoney(value);
            }
          },
          {
            key: 'actions',
            label: 'Ações',
            sortable: false,
          },
        ],
        items: [],
      },
      pagination: {
        currentPage: 1,
        itemsPerPage: 15,
        total: 0,
        lastPage: 0,
      },
      values: {
        waitingForDeadline: 0,
        amountPain: 0,
        valueGained: 0,
        waitingPayment: 0,
      },
      fields: {
        partnerName: '',
        startDate: '',
        endDate: '',
        status: [],
      },
    }
  },
  mounted() {
    this.getPartners();
  },
  watch: {
    'pagination.currentPage': function () {
      this.get();
    },
  },
  methods: {
    ...mapActions('shopkeeper', ['getAllPartners']),

    getPartners() {
      this.$store.dispatch('startLoader');
      this.loading = true;
      
      const data = {
        search: this.fields.partnerName,
        idShopkeeper: this.dadosUsuario.id,
      };

      this.getAllPartners(data).then((response) => {
          this.partners = response.data;
          this.get();
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
          this.loading = false;
        });
    },
    searchName() {
      this.fields.startDate = '';
      this.fields.endDate = '';
      this.fields.status = [];
      this.get();
    },
    searchDate() {
      this.fields.partnerName = '';
      this.fields.status = [];
      this.get();
    },
    searchStatus() {
      this.fields.startDate = '';
      this.fields.endDate = '';
      this.fields.partnerName = [];
      this.get();
    },
    clearFields() {
      this.fields.partnerName = '';
      this.fields.startDate = '';
      this.fields.endDate = '';
      this.fields.status = [];
      this.get();
    },
    async get() {
      this.loading = true;
      this.$store.dispatch('startLoader');

      const params = new URLSearchParams();
      params.append('page', this.pagination.currentPage);
      params.append('perPage', this.pagination.itemsPerPage);
      params.append('status', this.fields.status);
      params.append('name', this.fields.partnerName);
      params.append('startDate', this.fields.startDate);
      params.append('endDate', this.fields.endDate);

      try {
        const { data } = await shopkeeperAppApi.get(
          `products/partners/get-history-transfer/${this.dadosUsuario.id}?${params.toString()}`
        );

        const { items, total, perPage } = data.data;

        this.$set(this.table, 'items', items || []);

        this.values.waitingForDeadline = data.data.waitingForDeadline;
        this.values.amountPain = data.data.amountPain;
        this.values.valueGained = data.data.valueGained;
        this.values.waitingPayment = data.data.waitingPayment;

        this.pagination.total = total;
        this.pagination.itemsPerPage = perPage || 15;
      } catch {
        this.makeToast(
          'Erro',
          `Houve um ao buscar os dados`,
          'danger'
        );
      } finally {
          this.$store.dispatch('endLoader');
          this.loading = false;
      }
    },
    formatMoneyUn(value) {
      return formatMoney(value);
    },
    getNamePartner(id) {
      const partner = this.partners.find((partner) => partner.partner_id == id);
      return partner ? partner.nome_fantasia : '';
    },
    getDataPartner(id) {
      return this.partners.find((partner) => partner.partner_id == id);
    },
  },
}
</script>